import {
  Timestamp,
  arrayUnion,
  doc,
  addDoc,
  onSnapshot,
  serverTimestamp,
  updateDoc,
  deleteDoc,
  query,
  where,
  collection,
  setDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { v4 as uuid } from "uuid";
import moment from "moment/moment";
import { customOrderByASC, customOrderByDESC } from "./helper";

export const getQuestionsInRealTimeById = (id, cb) => {
  return onSnapshot(
    query(collection(db, "questions"), where("projectId", "==", id)),
    (doc) => {
      const messageSnaps = [];
      doc.forEach((each) => {
        const temp = each.data();
        const object = {
          ...temp,
          temp: temp.timestamp.seconds,
        };
        messageSnaps.push(object);
      });
      cb(customOrderByDESC(messageSnaps));
    }
  );
};

export const createQuestion = (id, text, senderId) => {
  const questionId = uuid();
  return setDoc(doc(db, "questions", questionId), {
    id: questionId,
    projectId: id,
    text,
    senderId: senderId,
    timestamp: Timestamp.now(),
  });
};

export const updateQuestion = (questionId, text) => {
  return updateDoc(doc(db, "questions", questionId), {
    text,
    editedAt: Timestamp.now(),
  });
};

export const deleteQuestion = (questionId) => {
  return deleteDoc(doc(db, "questions", questionId));
};
